<template>
  <login-wrapper>
    <h1>{{ message }}</h1>  
  </login-wrapper>
</template>

<script>
import LoginWrapper from '../components/LoginWrapper.vue'
export default {
  components: {LoginWrapper},
  data() {
    return {
      uuid: this.$route.params.uuid,
      messageOk: "Your registration is now confirmed",
      messageFail: "Invalid registration",
      status: null,
    }
  },
  
  mounted() {
    alert(this.uuid)
  },
  
  computed: {
    message() {
     
      switch(this.status) {
      case null:
        return "processing"
      case "ok":
        return this.messageOk
      case "error":
        return this.messageFail
      default:
	return "Unknown status"
      }
    }
  }

}
</script>

<style>

</style>
